var H = Object.defineProperty;
var R = (t, n, e) => n in t ? H(t, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[n] = e;
var N = (t, n, e) => R(t, typeof n != "symbol" ? n + "" : n, e);
import { createElementBlock as S, openBlock as O, createElementVNode as f, defineComponent as U, ref as _, computed as v, reactive as Z, watch as $, resolveComponent as x, createBlock as j, mergeProps as F, toHandlers as I, withCtx as m, renderSlot as E, createVNode as B } from "vue";
import K from "./Input-KouLK2QK.js";
import { u as L, m as M, a as q, b as z, c as C } from "./events-BZdEdnD6.js";
import { _ as G } from "./_plugin-vue_export-helper-CHgC5LLL.js";
function J(t, n) {
  return O(), S("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    f("path", { d: "M3.75 7.25a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5Z" })
  ]);
}
function Q(t, n) {
  return O(), S("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    f("path", { d: "M8.75 3.75a.75.75 0 0 0-1.5 0v3.5h-3.5a.75.75 0 0 0 0 1.5h3.5v3.5a.75.75 0 0 0 1.5 0v-3.5h3.5a.75.75 0 0 0 0-1.5h-3.5v-3.5Z" })
  ]);
}
const W = U({
  components: {
    TInput: K,
    PlusIcon: Q,
    MinusIcon: J
  },
  props: {
    modelValue: Number,
    formatter: Object,
    /** if modelModifiers float
     *    format number and add attribut step on input
     *    Ex: <Input precision="3" v-model=...
     * default: 0
     */
    precision: [String, Number],
    scale: Number,
    min: [Number, String],
    max: [Number, String],
    step: [Number, String],
    stepMandatory: Boolean
  },
  emits: ["update:model-value", "change", "input"],
  setup(t, { emit: n }) {
    const e = _(t.modelValue), l = v(() => {
      const a = typeof t.precision == "string" ? parseInt(t.precision) : t.precision;
      return a === void 0 || isNaN(a) || a < 0 ? 0 : a;
    }), o = v(() => t.min !== void 0 ? typeof t.min == "string" ? parseFloat(t.min) : t.min : void 0), u = v(() => t.max !== void 0 ? typeof t.max == "string" ? parseFloat(t.max) : t.max : void 0), i = v(() => t.step !== void 0 ? typeof t.step == "string" ? parseFloat(t.step) : t.step : 1), h = v(() => o.value !== void 0 ? o.value : 0), p = v(() => t.formatter ? ((u.value !== void 0 || o.value !== void 0) && t.formatter.validators.push(k(o.value, u.value)), t.formatter) : new tt(l.value, o.value, u.value, t.scale, t.stepMandatory && i.value ? i.value : void 0)), { focused: s, vOn: y } = L(), g = _(b(e.value)), P = Z({
      // type: "number",
      // pattern: "[0-9]*",
      inputmode: "numeric",
      formatter: p,
      value: v(() => e.value),
      errors: v(() => g.value),
      step: v(() => i.value ? i.value.toString() : X(l.value)),
      focused: v(() => s.value)
    });
    let c = e.value;
    function b(a) {
      if (a !== void 0) {
        if (u.value !== void 0 && a > u.value) return [`max ${u.value}`];
        if (o.value !== void 0 && a < o.value) return [`min ${o.value}`];
      }
      return [];
    }
    function w(a) {
      let r = c;
      r === void 0 ? r = h.value : a ? o.value !== void 0 && r < o.value ? r = o.value : u.value === void 0 ? r += i.value : u.value - r < i.value ? r = u.value : Math.abs(r + i.value) <= u.value && (r += i.value) : u.value !== void 0 && r > u.value ? r = u.value : o.value === void 0 ? r -= i.value : Math.abs(o.value - r) < i.value ? r = o.value : r - i.value >= o.value && (r -= i.value), e.value = r;
    }
    const d = (a) => {
      g.value = b(a), e.value = a, n("update:model-value", a), n("change", a);
    }, A = M(
      {
        input: (a) => {
          c = a, g.value = b(a);
        },
        change: (a) => {
          d(a);
        }
      },
      z(
        ["ArrowUp", "ArrowDown"],
        {
          up: () => {
            d(c);
          },
          downOrHold: (a) => {
            w(a === "ArrowUp");
          }
        }
      ).vOn,
      q({
        mouseOut: () => d(c)
      }).vOn
    ), D = M(
      C({
        click: () => {
          d(c);
        },
        hold: () => {
          w(!0);
        },
        prevent: !0,
        stop: !0
      }).vOn,
      y
    ), T = M(
      C({
        click: () => {
          d(c);
        },
        hold: () => {
          w(!1);
        },
        prevent: !0,
        stop: !0
      }).vOn,
      y
    );
    return $(l, (a) => {
      const r = `${e.value}`.replace(",", ".").replace(/\s/g, "").split("."), V = parseFloat(r.length < 2 ? r[0] : `${r[0]}.${r[1].substring(0, a)}`);
      V !== t.modelValue && d(V);
    }), $(() => t.modelValue, (a) => e.value = a), $(e, (a) => c = a), {
      inputOn: A,
      inputAttrs: P,
      buttonsFocused: s,
      buttonPlusOn: D,
      buttonMinusOn: T
    };
  }
});
function X(t) {
  return t === void 0 ? void 0 : `${t >= 1 ? [...Array(t - 1)].reduce((e) => `${e}0`, "0.") : ""}1`;
}
function Y(t = 0) {
  const n = t ? new RegExp(`^[-]{0,1}[\\d\\s]*[,|.]{0,1}[\\d]{0,${t}}$`) : new RegExp("^[-]{0,1}[\\d\\s]*$");
  return (e) => e === void 0 || e === "" || n.test(e);
}
function k(t, n) {
  return (e) => {
    if (e === void 0 || e === "" || e === "-") return !0;
    const l = parseFloat(e);
    return !(isNaN(l) || n !== void 0 && l > n || t !== void 0 && l < t);
  };
}
class tt {
  constructor(n = 2, e, l, o = 1, u) {
    N(this, "intlNumberFormat");
    N(this, "validators", []);
    this.scale = o, this.step = u, this.intlNumberFormat = new Intl.NumberFormat(void 0, {
      maximumFractionDigits: n,
      minimumFractionDigits: 0
    }), this.validators = [Y(n)], (e !== void 0 || l !== void 0) && this.validators.push(k(e, l));
  }
  stringify(n) {
    return n == null ? "" : this.intlNumberFormat.format(n * this.scale);
  }
  parse(n) {
    if (!n) return;
    const e = parseFloat(n.replace(",", ".").replace(/\s/g, ""));
    if (!isNaN(e))
      return this.step !== void 0 ? Math.round(e / this.scale / this.step) * this.step : e / this.scale;
  }
}
function et(t, n, e, l, o, u) {
  const i = x("MinusIcon"), h = x("PlusIcon"), p = x("TInput");
  return O(), j(p, F(t.inputAttrs, I(t.inputOn)), {
    start: m(({ focused: s }) => [
      E(t.$slots, "start", { focused: s })
    ]),
    startButton: m(({ focused: s }) => [
      f("div", F(I(t.buttonMinusOn, !0), {
        class: [{ "tt-invisible": !s, "tt-rounded-l-md": !(t.$attrs.start || t.$attrs.startIcon) }, "tt-border-r tt-bg-gray-50 tt-max-h-full tt-min-h-full tt-min-w-4 tt-max-w-4 tt-w-4 tt-flex tt-cursor-pointer tt-outline-none"]
      }), [
        B(i, { class: "tt-inline tt-m-auto" })
      ], 16)
    ]),
    endButton: m(({ focused: s }) => [
      f("div", F(I(t.buttonPlusOn, !0), {
        class: [{ "tt-invisible": !s, "tt-rounded-r-md": !(t.$attrs.end || t.$attrs.endIcon) }, "tt-border-l tt-bg-gray-50 tt-max-h-full tt-min-h-full tt-min-w-4 tt-max-w-4 tt-w-4 tt-flex tt-cursor-pointer tt-outline-none"]
      }), [
        B(h, { class: "tt-inline tt-m-auto" })
      ], 16)
    ]),
    end: m(({ focused: s }) => [
      E(t.$slots, "end", { focused: s })
    ]),
    _: 3
  }, 16);
}
const it = /* @__PURE__ */ G(W, [["render", et]]);
export {
  tt as NumberFormatter,
  it as default
};
//# sourceMappingURL=InputNumber-CJ1ZLzd0.js.map
